"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * @private
 * Hook for forked callbacks that accepts same parameters.
 * @param callbacks {Array<T extends (...args: never[]) => unknown | undefined>} list of callbacks
 * @returns {(...args: Parameters<T>) => void}
 */
function useForkCallback(...callbacks) {
  return (...args) => {
    callbacks.forEach(callback => callback?.(...args));
  };
}
var _default = exports.default = useForkCallback;
